<template>
  <v-container>
    <v-row>
      <v-col class="__form__plan">
        <div
          :class="{
            'display-2': $vuetify.breakpoint.mdAndUp,
            'display-1': $vuetify.breakpoint.smAndDown,
          }"
          class="font-weight-bold"
        >
          7 días gratis de prueba
        </div>
        <div class="mt-2 headline mb-2">Selecciona un plan</div>
        <v-form v-model="valid" style="width: 100%" @submit.prevent="submit" class="rounded-lg form__plan pa-2 mx-2 mb-8">
          <v-radio-group v-model="form.contract_type" :rules="requiredRule" class="mt-0 mb-0">
            <v-container class="mt-0 mb-0 pt-0 pb-0">
                <v-card
                  :elevation="
                    form.contract_type && form.contract_type == plan.id
                      ? 10
                      : 2
                  "
                  color="transparent"
                  class="plans d-flex justify-space-around mb-4 pt-0 pb-0 mt-0"
                  v-for="plan in contract_types"
                  :key="plan.id"
                  @click="selectPlan(plan.id)"
                >
                <v-card-text class="pt-1 pb-1">
                  <v-row>
                    <v-col cols="1" class="col pt-0">
                      <div class="flex-grow-1 d-flex align-center transparent pt-0">
                        <v-radio :value="plan.id" style="background-color: transparent"></v-radio>
                      </div>
                    </v-col>
                    <v-col cols="11" md="2" sm="10" class="col pt-0">
                      <div class="flex-grow-1 d-flex align-center headline transparent pt-0">
                        <span class="plan__name">{{ plan.name }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="3" sm="12" class="col pt-0">
                      <div class="flex-grow-1 d-flex align-center pt-0">
                        <span>
                          Hasta {{ plan.docs_num.toLocaleString('de-DE') }} docs/año
                        </span>
                      </div>
                    </v-col>

                    <v-col cols="12" md="3" sm="12" class="col pt-0">
                      <div class="flex-grow-1 d-flex align-center pt-0">
                        <span v-if="plan.name == 'Basic'">1 Usuario</span>
                        <span v-else-if="plan.name == 'Pro'">5 Usuarios</span>
                        <span v-else-if="plan.name == 'Premium'">10 Usuarios</span>
                        <span v-else>Usuarios ilimitados</span>
                      </div>
                    </v-col>
                  
                    <!-- <v-col cols="12" md="2" sm="12" class="col pt-0">
                      <div class="flex-grow-1 d-flex align-center pt-0">
                        <span>Gestión documental</span>
                      </div>
                    </v-col> -->
                    <v-col cols="12" md="3" sm="12"  class="col pt-0">
                      <div
                        class="flex-grow-1 d-flex align-center headline pt-0"
                        :class="{
                          selected: plan.id === form.contract_type,
                        }"
                      >
                        <span v-if="plan.duration.split(' ')[0] == '365'">{{ plan.price }} €/año*</span>
                        <span v-else> {{ plan.price }} €/{{ plan.duration.split(' ')[0] }} días</span>
                      </div>
                    </v-col>
                  </v-row>
                  </v-card-text>
                </v-card>
            </v-container>
          </v-radio-group>
          <small class="black--text">*Pago anual, impuestos no incluidos. Durante el periodo de prueba se podrán subir hasta 100 documentos.</small>

          <v-row  v-if="userData.available_features['feature_promotional_code']">
            <v-col cols="4">
              <v-text-field
                solo
                v-model="form.promotional_code"
                label="Código promocional"
                @input="promotional_code_error = false"
                :error="promotional_code_error"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-0">
              <v-checkbox
                v-model="form.contract_accepted"
                :rules="requiredRule"
              >
                <template v-slot:label>
                  <span  class="black--text">
                    He leído y acepto la
                    <PolicyDialogLink
                      name="Adhesión a la prestación de servicios"
                    >
                      <LegalContract 
                          :params="{
                            postal_address : userData.postal_address,
                            province : userData.province,
                            bussnies_id : userData.bussnies_id,
                            business_name : userData.business_name,
                            name : userData.name,
                            docs_num : selected_contract_type?selected_contract_type.docs_num.toLocaleString('de-DE'):'',
                            price : selected_contract_type?selected_contract_type.price.toLocaleString('de-DE'):'',
                            date : date
                            }"
                          kind="contract"
                          @contract-data="getServiceContractData"
                        />
                      <!-- <PolicyServices
                        :postal_address="userData.postal_address"
                        :province="userData.province"
                        :bussnies_id="userData.bussnies_id"
                        :business_name="userData.business_name"
                        :name="userData.name"
                        :docs_num="selected_contract_type?selected_contract_type.docs_num.toLocaleString('de-DE'):''"
                        :price="selected_contract_type?selected_contract_type.price.toLocaleString('de-DE'):''"
                        :date="date"
                      /> -->
                    </PolicyDialogLink>
                  </span>
                </template>
              </v-checkbox>
              <v-checkbox v-model="form.policy_accepted" :rules="requiredRule">
                <template v-slot:label>
                  <span class="black--text">
                    He leído y acepto la
                    <PolicyDialogLink name="Política de Privacidad">
                      <LegalContract 
                        :params="{
                          business_name : userData.business_name,
                          name : userData.name
                          }"
                        kind="data_treatment"
                        @contract-data="getDataTreatmentContractData"
                      />
                    </PolicyDialogLink>
                  </span>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row class="pr-2">
            <v-col cols="12" offset-md="8" md="2">
              <v-btn block color="secondary" @click="previousStep">
                Atrás
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                :disabled="!valid || submitting"
                block
                type="submit"
                color="secondary"
              >
                Siguiente
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PolicyDialogLink from "./PolicyDialogLink";
import LegalContract from "./LegalContract";
import PolicyServices from "./PolicyServices";
import ContratoTratamientoDatos from "./ContratoTratamientoDatos";
import { user as api_user } from "@/api/user";
import { STATUS } from "../../store/modules/me";
import ContractComponent from "../ContractComponent.vue";
import { mapFields } from 'vuex-map-fields';
import { connector as api_connector } from '@/api/connector'

export default {
  name: "SelectPlan",
  components: {
    PolicyDialogLink,
    PolicyServices,
    ContratoTratamientoDatos,
    ContractComponent,
    LegalContract,
  },
  data() {
    return {
      valid: false,
      submitting: false,
      form: {
        contract_accepted: false,
        policy_accepted: false,
        contract_type: undefined,
        promotional_code: '',
        status: STATUS.ACTIVE,
      },
      requiredRule: [(v) => Boolean(v) || "required"],
      plans: [
        {
          code: "u5000",
          docs: 5000,
          price: 30,
        },
        {
          code: "u20000",
          docs: 20000,
          price: 100,
        },
        {
          code: "u40000",
          docs: 40000,
          price: 167,
        },
        {
          code: "u90000",
          docs: 90000,
          price: 375,
        },
      ],
      date: '',
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],

      crispMsg: "Selección de contrato",
      promotional_code_error: false,
    };
  },
  created() {
    this.getContractTypes();
    this.fillForm();

    this.startCrispThread(this.crispMsg);
  },
  methods: {
    selectPlan(id) {
      this.form.contract_type = id;
    },
    previousStep() {
      this.$emit("previousStep");
    },
    async submit() {
      this.submitting = true;
      try {
        let is_promotional_code_valid = true;
        if (this.form.promotional_code) {
          is_promotional_code_valid = await this.isValidPromotionalCode(this.form.promotional_code);
        }
        if (is_promotional_code_valid) {
          const response_cdb = await api_connector.create_default_cdb_training();
          const config_response = await api_connector.config_user_for_use_inmatic();
          const response = await api_user.setUserInfo(this.form);
          await api_user.updateWelcomeTrialContract({ 'promotional_code': this.form.promotional_code });
          this.setUserData(response.data.results);
          await api_user.createLead({'state': 'trial'});
          this.endCrispThread(this.crispMsg);
          
          if (response_cdb.data.id) {
            await this.setCompanydbs();
            this.resetCurrentCompany({new_company: response_cdb.data});
            this.$router.push('/' + response_cdb.data.id + '/documents');
          } else {
            this.$router.push("/initial");
          }
        } else {
          this.promotional_code_error = true;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.submitting = false;
      }
    },
    fillForm() {
      this.form.contract_accepted = this.userData.contract_accepted;
      this.form.policy_accepted = this.userData.policy_accepted;
      this.form.contract_type = this.userData.contract_type;
    },
    ...mapActions({
      setUserData: "me/setUserData",
      getContractTypes: "contracts/getContractTypes",
      startCrispThread: "me/startCrispThread",
      endCrispThread: "me/endCrispThread",
      setCompanydbs: 'setCompanydbs',
      resetCurrentCompany: 'resetCurrentCompany',
      isValidPromotionalCode: 'contracts/isValidPromotionalCode',
    }),
    getServiceContractData: function (data) {
      this.form.service_contract = data['full_version']
    },
    getDataTreatmentContractData: function (data) {
      this.form.data_treatment_contract = data['full_version']
    }
  },
  computed: {
    ...mapGetters({
      userData: "me/userData",
    }),
    ...mapFields('contracts', ['contract_types']),
    selected_contract_type() {
      let ct = this.contract_types[0];
      for (let i in this.contract_types) {
        if (this.contract_types[i].id == this.form.contract_type) {
          ct = this.contract_types[i];
        }
      }
      return ct;
    },
  },
  watch: {
    userData: function () {
      this.fillForm();
    },
  },
  mounted() {
    let now = new Date();
    let day = now.getDate();
    let year = now.getFullYear();
    let month = now.getMonth()
    this.date = day + ' de ' + this.months[month] + ' de ' + year;
  },
};
</script>

<style lang="scss" scoped>

.form__plan {
  background-color: #F2F1FF
}
.plans .row .col div {
  cursor: pointer;
  background-color: var(--v-secondary-base);
  color: white;
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
  padding: 2px 10px;
  font-weight: bold;
  border-radius: 5px;
  height: 70%;
  &.transparent {
    background-color: transparent;
  }
  &.selected {
    background-color: yellow;
    color: var(--v-secondary-base);
  }
  span {
    margin: auto;
  }
}
.black--text {
  color: black;
}
.plan__name {
  color: black;
}
@media screen and (max-width: 960px) {

  .__form__plan {
    padding: 0 !important;
  }

  span.black--text {
    font-size: 14px !important; 
  }

}
</style>
